import React, { Component, Fragment } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {feedFetch, topicFeedFetch, authorFeedFetch, hashFeedFetch,  contentHubDataFetch} from '../../actions/index';
import {gtmSend} from '../../helpers';
// import { readCookie } from '@tickled-media/web-components.tm-helpers';
import update from 'react-addons-update';
// import style from './style.css';
// import Loader from '../../components/Common/Loader';
// import LoaderInline from '../../components/Common/Loader/Inline';
import {FeedPostPlaceholder} from '../../components/Common/ContentPlaceholder';
import LoadMoreButton from '../../components/Common/LoadMoreButton';
import QuestionElemContainer from '../Elems/QuestionElem';
import PollElemContainer from '../Elems/PollElem';
import ArticleElemContainer from '../Elems/ArticleElem';
import VideoElemContainer from '../Elems/VideoElem';
import EmptyPlaceholder from '../../components/Misc/EmptyPlaceholder';
import { translate } from 'react-i18next';

/**
 * This container is never used directly. If you are looking for feed landing pages, check Page Container
 */
class FeedContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageNumber: this.props.feedReducer.page,
            eof: {
                unanswered: false,
                author: {
                    posts: false,
                    replies: false
                },
                topicFeed: false,
                feed: false,
                hashFeed: false
            }            
        };
    }

    componentDidMount() {
        //in case parent element does not fill feed
        // if(!this.props.feedReducer.feedList.length && !this.props.feedReducer.ifInfiniteLoading){
        //     this.props.feedFetch(this.props.feedReducer.currentFeed, this.props.feedReducer.page, true, '/', this.props.feedReducer.filter);
        // }
        //add scroll handler
        if(typeof window != 'undefined'){
            window.addEventListener("scroll", this.bindScrollEvent);
        }
        if(this.props.isParentEmpty){
            this.props.feedFetch('popular', 1, true);
        }
    }

    componentDidUpdate(prevProps){
        if(this.state.eof.topicFeed && this.props.feedReducer.topic && this.props.feedReducer.topic.id != prevProps.feedReducer.topic.id){
            this.setState({
                eof: update(this.state.eof, {topicFeed: {$set: false}})
            });
        }

        if((this.state.eof.topicFeed || this.state.eof.feed || this.state.eof.hashFeed) && this.props.feedReducer.currentFeed != prevProps.feedReducer.currentFeed){
            this.setState({
                eof: update(this.state.eof, {topicFeed: {$set: false}, feed: {$set: false}, hashFeed: {$set: false}})
            });
        }
        
        if(this.props.feedReducer.currentFeed != prevProps.feedReducer.currentFeed){
            document.title = `Parenting Latest Feed: From Pregnancy To Parenthood - ${this.props.configReducer.region.keyword}`;
        }
    }

    componentWillUnmount() {
        //add scroll handler
        if(typeof window != 'undefined'){
            window.removeEventListener("scroll", this.bindScrollEvent);
        }
    }

    bindScrollEvent = () => {    
        if(window.scrollY >= document.body.scrollHeight - window.innerHeight - 4000) {
           if(!this.props.feedReducer.ifInfiniteLoading) this.infiniteScrollHandler();
        }
    }

    infiniteScrollHandler = () => {
        //return if end reached
        if(this.state.eof['unanswered'] || 
            this.state.eof['feed'] ||
            this.state.eof['hashFeed'] ||
            this.state.eof['topicFeed'] ||
            (this.props.currentFeed == 'posts' && this.state.eof.author['posts']) || 
            (this.props.currentFeed == 'replies' && this.state.eof.author['replies'])) return false;
        //add elems
        const page = ++this.props.feedReducer.page;
        if(this.props.subType && this.props.subType == 'topic' && this.props.feedReducer.feedList.length && this.props.feedReducer.has_next) {
            let nextTopicFeedLength;
            const prevTopicFeedLength = this.props.feedReducer.feedList.length;
            gtmSend('infinite scroll', 'topic', `scroll:${this.props.feedReducer.currentFeed}`, page);
            this.props.topicFeedFetch(this.props.feedReducer.currentFeed, page, null, this.props.feedReducer.topic.id, false, this.props.location.pathname, this.props.feedReducer.filter)
            .then(() => {
                nextTopicFeedLength = this.props.feedReducer.feedList.length;
                this.setState({pageNumber: this.props.feedReducer.page})
                if(prevTopicFeedLength == nextTopicFeedLength){
                    this.setState({
                        eof: update(this.state.eof, {topicFeed: {$set: true}})
                    });
                }
            });
        } 
        else if(this.props.subType && this.props.subType == 'topic' && this.props.feedReducer.feedList.length && !this.props.feedReducer.has_next){
            return
        }
        else if(this.props.subType && this.props.subType == 'author' && this.props.feedReducer.feedList.length) {
            gtmSend('infinite scroll', 'author', `scroll:${this.props.feedReducer.currentFeed}`, page);
            let nextAuthorLength;
            const prevAuthorLength = this.props.feedReducer.feedList.length;
            this.props.authorFeedFetch(this.props.feedReducer.currentFeed, page, this.props.feedReducer.author.id, false, this.props.location.pathname, this.props.feedReducer.filter)
            .then(() => {
                nextAuthorLength = this.props.feedReducer.feedList.length;
                if(prevAuthorLength == nextAuthorLength) {
                    this.setState({
                        eof: update(this.state.eof, {
                            author: {
                                [this.props.currentFeed == 'posts' ? 'posts' : 'replies']: {$set: true},
                                [this.props.currentFeed == 'posts' ? 'replies' : 'posts']: {$set: false}
                            }
                        })
                    });
                }
            });
        } 
        else if(this.props.subType && this.props.subType == 'unanswered' && this.props.feedReducer.feedList.length) {
            let nextUnansweredLength;
            const prevUnansweredLength = this.props.feedReducer.feedList.length;
            this.props.unansweredFeedFetch(this.props.feedReducer.currentFeed, this.props.feedReducer.countryId, 0, page, false, this.props.location.pathname, this.props.feedReducer.filter)
            .then(() => {
                nextUnansweredLength = this.props.feedReducer.feedList.length;
                if(prevUnansweredLength == nextUnansweredLength) {
                    this.setState({
                        eof: update(this.state.eof, {unanswered: {$set: true}})
                    });
                }
            });
        } 
        else if(this.props.feedReducer.currentFeed == 'hash' && this.props.feedReducer.feedList.length){
            let nextFeedLength;
            const prevFeedLength = this.props.feedReducer.feedList.length;
            gtmSend('infinite scroll', 'hash feed', `scroll:${this.props.feedReducer.currentFeed}`, page);
            this.props.hashFeedFetch(this.props.match.params.slug, page, false, this.props.location.pathname)
            .then(() => {
                nextFeedLength = this.props.feedReducer.feedList.length;
                if(prevFeedLength == nextFeedLength){
                    this.setState({
                        eof: update(this.state.eof, {hashFeed: {$set: true}})
                    });
                }
            });
        }
        else if(this.props.feedReducer.feedList.length && this.props.contentHub){
            let nextFeedLength;
            const prevFeedLength = this.props.feedReducer.feedList.length;
            gtmSend('infinite scroll', 'feed', `scroll:${this.props.feedReducer.currentFeed}`, page);
            this.props.contentHubDataFetch(this.props.campaignName, this.props.selectedTab,page ,`${this.props.selectedTab=='poll'? 'poll': 'newsfeed'}`,true, false)
            .then(() => {
                nextFeedLength = this.props.feedReducer.feedList.length;
                if(prevFeedLength == nextFeedLength){
                    this.setState({
                        eof: update(this.state.eof, {feed: {$set: true}})
                    });
                }
            });
        }
        else if(this.props.feedReducer.feedList.length) {
            let nextFeedLength;
            const prevFeedLength = this.props.feedReducer.feedList.length;
            gtmSend('infinite scroll', 'feed', `scroll:${this.props.feedReducer.currentFeed}`, page);
            this.props.feedFetch(this.props.feedReducer.currentFeed, page, false, this.props.location.pathname, this.props.feedReducer.currentFilter, this.props.feedReducer.currentFilterId)
            .then(() => {
                nextFeedLength = this.props.feedReducer.feedList.length;
                if(prevFeedLength == nextFeedLength){
                    this.setState({
                        eof: update(this.state.eof, {feed: {$set: true}})
                    });
                }
            });
        }
        
    }

    cardFactory = (data, index) => {
        let elem = null;
        // build
        switch(data.type) {
            case 'question':
                elem = <QuestionElemContainer key={index}
                    index={index} 
                    match={this.props.match}
                    inFeed={true} 
                    type={'question'}
                    id={data.topic.id} 
                    data={data}
                    subType={this.props.subType}
                    contentHub={this.props.contentHub} />;
            break;
            case 'poll':
                elem = <PollElemContainer key={index}
                    index={index} 
                    match={this.props.match}
                    inFeed={true} 
                    type={'poll'}
                    id={data.topic.id} 
                    data={data}
                    subType={this.props.subType}
                    contentHub={this.props.contentHub} />;
            break;
            case 'article':
                elem = <ArticleElemContainer key={index}
                    index={index} 
                    inFeed={true} 
                    type={'article'}
                    id={data.topic.id} 
                    match={this.props.match}
                    subType={this.props.subType}
                    data={data} />;
            break;
            case 'video':
                elem = <VideoElemContainer key={index}
                    index={index} 
                    inFeed={true} 
                    type={'video'}
                    id={data.topic.id} 
                    match={this.props.match}
                    subType={this.props.subType}
                    data={data} />;
            break;
            default:
                elem = null;
        }        
        return elem;
    }

    render() {
        const {injectElem, feedReducer, t, trackerCardBanner} = this.props;
        const finalFeed = feedReducer.feedList.map((data, i) => {
            //if injecting something
            /*if(injectElem && i == 2) {
                return <Fragment key={i}>
                    { injectElem }
                    { this.cardFactory(data, i) }
                </Fragment> 
            } else {
                return this.cardFactory(data, i)
            }*/  

            return (
                <Fragment key={i}>
                    {
                        injectElem && i == 2 &&
                        injectElem
                    }
                    {
                        trackerCardBanner && i !== 0 && i % 4 == 0 &&
                        <div className="only-mobile" >{trackerCardBanner((i % 8 == 0 ? 'baby' : 'pregnancy'), (i % 8 == 0 || i % 12 == 0 ? 2 : 1))}</div>
                    }
                    {
                        this.cardFactory(data, i)
                    }
                </Fragment> 
            );
        });

        return (
            <div className="feed" ref="iScroll">
                { 
                    feedReducer.feedList.length
                    ?
                        finalFeed
                    :
                        !feedReducer.ifInfiniteLoading &&
                        <EmptyPlaceholder content={t('search_empty')} />
                }
                { this.props.subType !== 'topic' && feedReducer.ifInfiniteLoading && <FeedPostPlaceholder /> } 
                { this.props.subType === 'topic' && feedReducer.feedList.length > 0 && feedReducer.has_next && <LoadMoreButton page={this.state.pageNumber} slug={`/topic/${this.props.match.params.slug}`} infiniteLoading={feedReducer.ifInfiniteLoading} appReducer={this.props.appReducer} t={t}/> }
            </div>
        );
    }

}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        feedFetch,
        hashFeedFetch,
        topicFeedFetch,
        authorFeedFetch,
        contentHubDataFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(FeedContainer));
